// Deterministic "affirmation of the day". Same day = same affirmation across
// all users and reloads. Rotates:
//   • theme every day (10 themes → full cycle every 10 days)
//   • affirmation index within a theme also advances so the user sees a fresh
//     one on repeat visits to the same theme days later
import { manifestThemes } from '../data/manifestData';

const startOfLocalDay = (d = new Date()) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};

const dayOfEpoch = (d = new Date()) => {
  // Number of local days since Jan 1 2020 — stable, monotonic.
  const epoch = Date.UTC(2020, 0, 1);
  return Math.floor((startOfLocalDay(d).getTime() - epoch) / (24 * 60 * 60 * 1000));
};

export const getDailyManifest = (d = new Date()) => {
  const day = dayOfEpoch(d);
  const themeIdx = day % manifestThemes.length;
  const theme = manifestThemes[themeIdx];
  // Move through affirmations at a rate that ensures variety across cycles.
  // With 30 affirmations and 10 themes, a stride of 7 gives full coverage.
  const affIdx = (Math.floor(day / manifestThemes.length) * 7 + day) % theme.affirmations.length;
  const affirmation = theme.affirmations[affIdx];
  const imagePool = theme.images || [];
  const image = imagePool.length ? imagePool[affIdx % imagePool.length] : null;
  return { theme, affirmation, index: affIdx, image };
};
